// Lightweight Arabic-name gender heuristic.
// Returns 'female' if the name LIKELY belongs to a female; otherwise 'male' (default).
// Used purely for personalising cheering text — no business logic depends on it.

const FEMALE_ENDINGS = ['ة', 'اء', 'ى'];

// Curated list of common Saudi/Arab female first names that don't match the
// ending-based heuristic (e.g., نوره with ه instead of ة, or short names).
const FEMALE_NAMES = new Set([
  'نوره', 'نورة', 'نور', 'سارة', 'ساره', 'سارا', 'ابرار', 'إبرار',
  'هند', 'رهف', 'وعد', 'شهد', 'بشاير', 'دلال', 'هيا', 'رنا',
  'دانة', 'دانه', 'لمى', 'جوري', 'تالا', 'تالة', 'تاله', 'جنى',
  'مها', 'حنين', 'رزان', 'لطيفة', 'لطيفه', 'حصة', 'حصه', 'منيرة', 'منيره',
  'العنود', 'الجوهرة', 'الجوهره', 'الجازي', 'مزنه', 'مزنة', 'موضي', 'موضى',
  'منى', 'سلمى', 'ليلى', 'سلوى', 'هدى', 'نجلاء', 'سمر', 'سهى', 'إيمان',
  'ايمان', 'ندى', 'أمل', 'امل', 'وفاء', 'أسماء', 'اسماء', 'إيناس', 'ايناس',
  'مودة', 'موده', 'دانية', 'دانيه', 'تماره', 'تمارة', 'لمار', 'ريم',
  'غزل', 'غادة', 'غاده', 'بشرى', 'بشاير', 'لين', 'ليان', 'لجين',
]);

const MALE_OVERRIDES = new Set([
  // Names that end with ة/اء but are male
  'حمزة', 'حمزه', 'معاوية', 'معاويه', 'أسامة', 'اسامة', 'اسامه',
  'عبد الله', 'عبدالله', 'عبد القادر', 'يحيى', 'مصطفى', 'موسى', 'عيسى',
  'علاء', 'بهاء', 'ضياء', 'صفاء', 'زكريا', 'زكرياء',
]);

export const detectGender = (rawName) => {
  if (!rawName || typeof rawName !== 'string') return 'male';
  // Take the first token (given name) — strip non-Arabic chars and trim
  const first = rawName.trim().split(/\s+/)[0];
  if (!first) return 'male';
  if (MALE_OVERRIDES.has(first)) return 'male';
  if (FEMALE_NAMES.has(first)) return 'female';
  // Ending-based heuristic (last resort)
  if (FEMALE_ENDINGS.some((e) => first.endsWith(e))) return 'female';
  return 'male';
};

// Returns the cheering message based on name + whether target was exceeded.
export const cheerMessage = (name, exceeded = false) => {
  const safe = (name || '').trim();
  const isFemale = detectGender(safe) === 'female';
  if (isFemale) {
    return exceeded
      ? `كفو ${safe} يالشيخة جبتيها وزود`
      : `كفو ${safe} يالشيخة جبتيها`;
  }
  return exceeded
    ? `كفو ${safe} جبتها وعديتها`
    : `كفو ${safe} جبتها`;
};
